module.exports = __webpack_public_path__ + "img/logo-faberlic.1a377c8.jpg";